// field-type
export const FIELD_TYPE = {
    INPUT: 'input',
    TEXT: 'text',
    EMAIL: 'email',
    PASSWORD: 'password',
    TEXTAREA: 'textarea',
    ADDRESS: 'address',
    RADIO: 'radio',
    RADIO_GROUP: 'radioGroup',
	CHECKBOX: 'checkbox',
    CHECKBOX_GROUP: 'checkboxGroup',
    SINGLE_SELECT: 'singleSelect',
    MULTI_SELECT: 'multiSelect',
    DATE_FIELD: 'dateField',
    DATE_RANGE: 'dateRange',
    FILE_UPLOAD: 'fileUpload',
    SEARCH: 'search',
    DEEP_SELECT: 'deepSelect',
    FORM_SECTION_TITLE: 'formSectionTitle',
    TYPE_AHEAD: 'typeAhead',
    TYPE_AHEAD_WITH_SEARCH: 'TypeAheadWithSearch',
    COMPOSITE_FIELD: 'compositeField',
    FORM_SECTION_DESCRIPTION: 'formSectionDescription'
};
